import { Maybe, None, Some } from "../../../../misc/option";
export class StrategyContainer {
    constructor(strategies) {
        this.strategies = strategies;
        this._current = None.instance();
        this._inputs = [
            'colorize-field',
            'colorize-numcolors',
            'colorize-gradient',
            'colorize-startcolor',
            'colorize-endcolor',
            'colorize-strategy',
            'colorize-opacity'
        ];
    }
    get current() { return this._current; }
    select_first(gradient = false) {
        if (gradient) {
            if (this.gradients.length === 0)
                return;
            this.select_strategy(this.gradients[0]);
            return;
        }
        if (this.categoricals.length === 0)
            return;
        this.select_strategy(this.categoricals[0]);
    }
    select_strategy(s) {
        if (!s)
            return;
        if (this.current.mapOr(false, current => current === s))
            return;
        for (let input of this._inputs) {
            $('#' + input).addClass('hidden');
        }
        for (let input of s.visible_inputs()) {
            $('#' + input).removeClass('hidden');
        }
        this._current = new Some(s);
    }
    get gradients() { return this.strategies.filter(s => s.is_gradient); }
    get categoricals() { return this.strategies.filter(s => !s.is_gradient); }
    find(strategy_name) {
        const s = this.strategies.find(strat => strat.name === strategy_name);
        return Maybe(s);
    }
    add(...strategies) {
        this.strategies.push(...strategies);
    }
}
